import React from "react";
// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import anandImg1 from '../assets/img/anand-img-1.jpg';
import linkedinIcon1 from '../assets/img/linkedin-icon-1.svg';

function Aboutus() {

  // useEffect(()=>{
  //   document.title = 'Elixir | About Us';
  // }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>About Us</span></h1>
                <h4>Quality, Commitment, trust, Achievement</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="aboutPages-box2">
                  <img src={require('../assets/img/about-page-banner-1.jpg')} className="img-fluid" alt="elixir" />
                  <a href="https://www.linkedin.com/company/elixir-worldwide-advertising-agency/about/" target="_blank" className="aboutPages-box2-link">
                    <img src={linkedinIcon1} className="img-fluid" alt="Elixir" />
                  </a>
                </div>
              </div>
            </Col>
            {/* <Col lg={3}>
              <div className="innerPages-box3">
                <div className="aboutPages-photo">
                  <img src={anandImg1} className="img-fluid" alt="Elixir" />
                  <div className="aboutPages-photo-name">
                    <div>
                      <h5>Ananda Ganesh N</h5>
                      <h6>Chief Executive</h6>
                    </div>
                    <a href="https://www.linkedin.com/in/ananddreams/" target="_blank" className="aboutPages-photo-link">
                      <img src={linkedinIcon1} className="img-fluid" alt="Elixir" />
                    </a>
                  </div>
                </div>
              </div>
            </Col> */}
            <Col lg={3}> 
              <div className="innerPages-box3">      
                <div className="logoPart">
                  <h5><span>"</span>A Complete Communication Solutions<span>"</span></h5>
                  <hr />
                  <p><span>Mail:</span> <a href="mailto:anand@elixirworldwide.com">anand@elixirworldwide.com</a></p>
                  <p><span>Mobile:</span> <a href="tel:+966552301809">+966 55 230 1809</a></p>         
                </div>
              </div>     
            </Col>
          </Row>
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">
                <div className="contactMap-text">
                  <h3>"Brainstorming is the first step to choose a catch and successful name"</h3>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="aboutPages-box5">
                <h4>About - Company Profile</h4>
                <p>Welcome to Elixir Advertising & AR Graphics – an award-winning advertising and signage printing company dedicated to empowering businesses and brands to navigate the digital landscape and connect meaningfully with their customers.</p>     
                <Row>
                  <Col lg={6}>
                    <img src={require('../assets/img/appreciation-letter-img-1.jpg')} className="img-fluid certificateImg" alt="elixir" /> 
                  </Col>
                  <Col lg={6}>
                    <img src={require('../assets/img/appreciation-letter-img-2.jpg')} className="img-fluid certificateImg" alt="elixir" /> 
                  </Col>
                </Row>                  
                <div className="titlPara">A Complete Communication Solution:</div>
                <h5>Real People + Real Passion + Real Experience = The Elixir & AR Graphics Team</h5>
                <p className="pt-2">We are more than a service provider—we are a complete communication solutions partner with a network of diverse capabilities, deeply rooted in local culture yet global in outlook. With creativity, strategy, and flawless execution, we deliver measurable results that drive conversions, engagement, and long-term impact.</p>
                <p>Our ideas are tested and proven—trusted by leading international brands as well as ambitious start-ups competing in dynamic markets. With extensive experience across industries and technologies, we create tailored solutions for unique challenges.</p>
                <p>At Elixir & AR Graphics, we believe in the power of simplicity—turning bold ideas into clear, effective, and impactful communication.</p>
                <div className="titlHead">“We love the Simplicity.”</div>
                <hr />
                <h4>Vision</h4>
                <p>To be the region’s most trusted and innovative advertising partner, recognized for reliability, creativity, and professional excellence.</p>
                <h4>Mission</h4>
                <p>To deliver impactful advertising, signage, printing and digital solutions by driving operational efficiency, embracing innovation, and striving for continuous improvement empowering brands to connect, engage, and grow.</p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Aboutus;
